import { Button } from 'antd';
import classNames from 'classnames/bind';
import React from 'react';
import styles from './index.less';


const cx = classNames.bind(styles);

const CardBackGround = ({
  type,
  time,
  titleText,
  totalNumber,
  action,
  btnText,
}) => (
  <div className={cx(`${type}-modal`, `${time}-modal`)}>
    {_.isNumber(totalNumber) && <p className={cx(`${time}-modal-number`)}>{totalNumber}</p>}
    {titleText && <p className={cx(`${time}-modal-text`)}>{titleText}</p>}
    {action &&
      <Button
        onClick={() => action(type)}
        className={cx('btn-ellipse ml-sm', 'viewMore-btn')}
        size="small"
      >
        {btnText}
      </Button>
    }
  </div>
);

export default CardBackGround;



// WEBPACK FOOTER //
// ./src/views/Dashboard/components/leftTopModal/cardBackGround.jsx